import filter from 'lodash/filter'
import React from 'react'
import { queries } from '../graphql'
import { useConfirmDialog, useMutation } from '@ztechapps/common.hook'
import { BusyButton } from '@ztechapps/webui.button'
import { truncate } from '@ztechapps/common.utils'

export const DeleteBoardItem = ({ _id, product, board }) => {
  const { confirm } = useConfirmDialog({
    title: `'${truncate(product?.name, 50)}' will be removed from your favorite.`,
  })
  const [onRemoveItem] = useMutation({ ...queries.updateConfig })
  const onClick = () => {
    confirm(async () => {
      const items = filter(board.items, (e) => e._id !== _id)
      const input = {
        _id: board?._id,
        items,
      }
      await onRemoveItem({ input })
    })
  }

  return <BusyButton bsStyle="danger" onClick={onClick} icon="trash" text="Delete this product from favorites" />
}
